import React, { useContext, useMemo } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import DataRoomContext from 'router/subrouters/DataRoom/providers/DataRoom/DataRoom.context';
import { Button } from 'ncoded-component-library';
import ChatIcon from 'icons/Chat.icon';

import './MessageSellSideButton.styles.scss';

type MessageSellSideButtonProps = {
  className?: string;
};

const MessageSellSideButton: React.FC<MessageSellSideButtonProps> = (props) => {
  const { className } = props;

  const {
    isBuySide,
    dataRoom: {
      currentMember: { sessionId },
    },
    openChatDrawer,
  } = useContext(DataRoomContext);

  const canMessageSellSide = useMemo(
    () => isBuySide && sessionId,
    [isBuySide, sessionId],
  );

  const classes = classNames('message-sell-side-button', className);

  const { t } = useTranslation();

  if (!canMessageSellSide) return null;

  return (
    <Button
      className={classes}
      variant="outline"
      icon={ChatIcon}
      onClick={() => openChatDrawer(sessionId)}
    >
      {t('messageSellSide')}
    </Button>
  );
};

export default MessageSellSideButton;
